export const Close: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Group 35">
      <rect
        id="Rectangle 24"
        y="1.40039"
        width="1.9799"
        height="17.8191"
        rx="0.989949"
        transform="rotate(-45 0 1.40039)"
        fill="currentColor"
      />
      <rect
        id="Rectangle 25"
        x="1.3999"
        y="14"
        width="1.9799"
        height="17.8191"
        rx="0.989949"
        transform="rotate(-135 1.3999 14)"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const Loading: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="5 5 42 42" {...props}>
    <path
      fill="currentColor"
      d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
      transform="rotate(275.098 25 25)"
    >
      <animateTransform
        attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="1s"
        repeatCount="indefinite"
      />
    </path>
  </svg>
)

export const Omit: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    version="1.1"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    {...props}
  >
    <g>
      <g>
        <path
          d="M10.5,7C10.5,7.48324,10.89178,7.875,11.375,7.875C11.8582,7.875,12.25,7.48324,12.25,7C12.25,6.516758,11.8582,6.125,11.375,6.125C10.89178,6.125,10.5,6.516758,10.5,7ZM2.625,7.875C2.141785,7.875,1.75,7.48324,1.75,7C1.75,6.516758,2.141785,6.125,2.625,6.125C3.10822,6.125,3.5,6.516758,3.5,7C3.5,7.48324,3.10822,7.875,2.625,7.875ZM6.125,7C6.125,7.48324,6.51678,7.875,7,7.875C7.48322,7.875,7.875,7.48324,7.875,7C7.875,6.516758,7.48322,6.125,7,6.125C6.51678,6.125,6.125,6.516758,6.125,7Z"
          fill="currentColor"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
)

export const Prev: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Group 31">
      <path
        id="Rectangle 18"
        d="M16.5 11.5004C16.4998 11.7432 16.414 11.978 16.2587 12.1594C16.1034 12.3409 15.8893 12.4567 15.6573 12.4849L15.5467 12.4918L8.75444 12.4918L10.4971 14.3042C10.6699 14.4822 10.7707 14.7221 10.7789 14.9749C10.7872 15.2277 10.7022 15.4742 10.5414 15.664C10.3806 15.8538 10.1562 15.9725 9.91401 15.9958C9.67184 16.0191 9.43025 15.9452 9.23872 15.7894L9.14911 15.7061L5.77918 12.2013C5.61505 12.0306 5.51645 11.8035 5.50188 11.5625C5.48731 11.3216 5.55778 11.0834 5.70006 10.8926L5.77918 10.7994L9.14911 7.29372C9.32026 7.11402 9.55099 7.00915 9.79406 7.00057C10.0371 6.99199 10.2742 7.08036 10.4566 7.24759C10.6391 7.41481 10.7532 7.64825 10.7756 7.90011C10.798 8.15197 10.727 8.40322 10.5772 8.60242L10.4971 8.69562L8.75444 10.51L15.5467 10.51C15.7995 10.51 16.042 10.6144 16.2208 10.8003C16.3994 10.9861 16.4998 11.2377 16.5 11.5004Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export const Next: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g id="Group 32">
      <path
        id="Rectangle 18"
        opacity="0.5"
        d="M5.5 11.5004C5.50015 11.7432 5.586 11.978 5.74127 12.1594C5.89662 12.3409 6.11065 12.4567 6.34272 12.4849L6.4533 12.4918L13.2456 12.4918L11.5029 14.3042C11.3301 14.4822 11.2293 14.7221 11.2211 14.9749C11.2128 15.2277 11.2978 15.4742 11.4586 15.664C11.6194 15.8538 11.8438 15.9725 12.086 15.9958C12.3282 16.0191 12.5697 15.9452 12.7613 15.7894L12.8509 15.7061L16.2208 12.2013C16.385 12.0306 16.4836 11.8035 16.4981 11.5625C16.5127 11.3216 16.4422 11.0834 16.2999 10.8926L16.2208 10.7994L12.8509 7.29372C12.6797 7.11402 12.449 7.00915 12.2059 7.00057C11.9629 6.99199 11.7258 7.08036 11.5434 7.24759C11.3609 7.41481 11.2468 7.64825 11.2244 7.90011C11.202 8.15197 11.273 8.40322 11.4228 8.60242L11.5029 8.69562L13.2456 10.51L6.4533 10.51C6.20047 10.51 5.95799 10.6144 5.77921 10.8003C5.60057 10.9861 5.50015 11.2377 5.5 11.5004Z"
        fill="currentColor"
      />
    </g>
  </svg>
)
